import { render, staticRenderFns } from "./UnsupportBrowsers.vue?vue&type=template&id=319d3cc2&"
import script from "./UnsupportBrowsers.vue?vue&type=script&lang=js&"
export * from "./UnsupportBrowsers.vue?vue&type=script&lang=js&"
import style0 from "./UnsupportBrowsers.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports